import PropTypes from 'prop-types';
import { Mask } from 'components/common';
import { LOAN_TYPE } from 'consts';

const MaskDestination = ({ decrypt, icon, item }) => {
  const {
    coreAccountNumberMask,
    coreAccountType,
    destination,
    coreAccountNumber,
    destinationAccountSuffix,
    destinationMask,
  } = item;
  const isLoan = coreAccountType === LOAN_TYPE;
  const maskValue = isLoan
    ? coreAccountNumberMask ?? destinationMask
    : destinationMask || destination;

  const handleApi = () => {
    if (coreAccountNumber) {
      return Promise.resolve(coreAccountNumber);
    }
    return decrypt(item);
  };

  return (
    <Mask
      api={handleApi}
      icon={icon}
      prefix={destination}
      suffix={isLoan ? undefined : destinationAccountSuffix}
      value={maskValue ?? undefined}
    />
  );
};

MaskDestination.propTypes = {
  decrypt: PropTypes.func.isRequired,
  icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  item: PropTypes.object.isRequired,
};

MaskDestination.defaultProps = {
  icon: false,
};

export default MaskDestination;
